<template>
  <div data-testid="admin_signup_pages">
    <v-toolbar grey dense>
      <v-toolbar-title>{{ $t("admin_signup_pages.title") }}</v-toolbar-title>
      <v-spacer />
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('common.search')"
        single-line
        hide-details
        data-testid="admin_signup_pages_search"
      />
      <v-spacer />
      <v-btn small color="primary" @click="create_page" data-testid="admin_signup_pages_create">
        {{ $t("admin_signup_pages.create") }}
      </v-btn>
    </v-toolbar>

    <v-data-table
      :items="filtered_pages"
      :headers="headers"
      :items-per-page="100"
      :search="search"
    >
      <template v-slot:item.url="{ item }">
        <a :href="'/app/signup/' + item.id" target="_blank" data-testid="admin_signup_pages_public_url">/app/signup/{{ item.id }}</a>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn icon @click="edit_page(item)" data-testid="admin_signup_pages_edit">
          <v-icon small>edit</v-icon>
        </v-btn>
        <v-btn icon @click="delete_page(item)" data-testid="admin_signup_pages_delete">
          <v-icon small>delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog v-model="editor_open" max-width="1200" persistent>
      <SignupPageEdit
        v-if="editor_open && editing_page"
        :value="editing_page"
        :clinics="clinics"
        @close="editor_open = false"
        @saved="page_saved"
      />
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import SignupPage from "../../classes/signup_page";
import SignupPageEdit from "./SignupPageEdit.vue";

export default {
  components: { SignupPageEdit },
  data() {
    return {
      pages: [],
      clinics: [],
      search: "",
      editor_open: false,
      editing_page: null,
      headers: [
        { text: this.$t("common.title"), value: "title" },
        { text: this.$t("admin_signup_pages.public_url"), value: "url" },
        { text: "", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    filtered_pages() {
      return this.pages;
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      axios.get("/api/signup_page").then((response) => {
        if (response.data.status == "error") {
          messageBus.$emit("api-error", response.data);
          return;
        }
        this.pages = response.data.data.map((page) => SignupPage.fromJson(page));
      });
      axios.get("/api/clinic").then((response) => {
        if (response.data.status == "success") {
          this.clinics = response.data.data;
        }
      });
    },
    create_page() {
      this.editing_page = SignupPage.newPage();
      this.editor_open = true;
    },
    edit_page(page) {
      this.editing_page = SignupPage.fromJson(JSON.parse(JSON.stringify(page)));
      this.editor_open = true;
    },
    page_saved() {
      this.editor_open = false;
      this.load();
    },
    delete_page(page) {
      if (!confirm(this.$t("admin_signup_pages.confirm_delete"))) {
        return;
      }
      axios.delete("/api/signup_page/" + page.id).then((response) => {
        if (response.data.status == "error") {
          messageBus.$emit("api-error", response.data);
          return;
        }
        this.load();
      });
    },
  },
};
</script>
